import React from 'react';
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import {Icon} from 'react-icons-kit';
import {menu} from 'react-icons-kit/feather/menu';
import {arrowLeft} from 'react-icons-kit/feather/arrowLeft'

function Edit() {
    return (
        <div className="dashboard-content">
        <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div>
        <div className="body-cart tab-content dasContent p-4 bg-white rounded">
          <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
              <h1 className="heading h4 mb-0 fw-bold">Seller Management Edit</h1>
              <div className="d-inline-flex gap-2">
                  <NavLink to="#" className="btn btn-primary">View All</NavLink>
                  <NavLink to="#" className="btn btn-outline-primary"><Icon className="arrowLeft" icon={arrowLeft} size={18}/> Back</NavLink>
              </div>
          </div>
          <div role="tabpanel" className="personal-info tab-pane active" id="pi">
            <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4>
            <div className="row">
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating">
                      <select className="form-select" id="store" aria-label="Store Name">
                          <option defaultValue>Select</option>
                          <option value="1">One</option>
                          <option value="2">Two</option>
                          <option value="3">Three</option>
                      </select>
                      <label htmlFor="store">Store Name</label>
                  </div>
              </div>
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <div className="form-floating mb-4">
                    <input type="text" className="form-control" id="catName" placeholder="Product Main Category Name" />
                    <label htmlFor="catName">Product Main Category Name</label>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating">
                      <select className="form-select" id="status" aria-label="Product Main Category Status">
                          <option defaultValue>Select</option>
                          <option value="1">One</option>
                          <option value="2">Two</option>
                          <option value="3">Three</option>
                      </select>
                      <label htmlFor="status">Product Main Category Status</label>
                  </div>
              </div>
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <div className="form-floating mb-4">
                    <input type="file" className="form-control" id="catImg" placeholder="Product Main Category Image" />
                    <label htmlFor="catImg">Product Main Category Image</label>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-sm-12 col-lg-12 mb-3">
                <button type="submit" className="btn btn-danger btn-lg save-btn text-uppercase">Descard</button> &nbsp;
                <button type="submit" className="btn btn-primary btn-lg save-btn text-uppercase">Save</button>
              </div>
            </div>
          </div>
          <hr />
          <div role="tabpanel" className="address-info" id="ai">
            <h4 className="text-primary h6 fw-bold mb-4">SEO Information</h4>
            <div className="add-new-address-section">
              <div className="row">
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                    <label className="fw-bold">SEO Title</label>
                    <input className="form-control form-control-lg" type="text" placeholder="SEO Title" />
                </div>
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                    <label className="fw-bold">SEO Keywords</label>
                    <input className="form-control form-control-lg" type="text" placeholder="SEO Keywords" />
                </div>
                
                <div className="form-group col-sm-12 mb-3">
                  <label className="fw-bold">SEO Description</label>
                  <textarea className="form-control form-control-lg" placeholder="SEO Description" rows="3"></textarea>
                </div>
                <div className="form-group col-sm-12 mb-3">
                    <button type="submit" className="btn btn-danger btn-lg">Descard</button> &nbsp;
                    <button type="submit" className="btn btn-primary btn-lg save-btn">Save</button>
                </div>
              </div>
            </div>
          </div>
        </div>
    
      </div>
    );
  }
export default Edit;
